const getComponent = (components, type) =>
  components.find((component) => component.types?.includes(type));

const getComponentText = (component) =>
  component?.longText || component?.long_name || "";

export const parseGoogleAddressComponents = (components = []) => {
  const locality =
    getComponent(components, "locality") ||
    getComponent(components, "administrative_area_level_2");

  return {
    calle: getComponentText(getComponent(components, "route")),
    numero: getComponentText(getComponent(components, "street_number")),
    localidad: getComponentText(locality),
    provincia: getComponentText(
      getComponent(components, "administrative_area_level_1"),
    ).replace("Provincia de ", ""),
    codigoPostal: getComponentText(
      getComponent(components, "postal_code"),
    ).replace(/\D/g, ""),
  };
};

export const getPlacePredictionLabel = (prediction) =>
  prediction?.text?.text ||
  [prediction?.mainText?.text, prediction?.secondaryText?.text]
    .filter(Boolean)
    .join(", ");

export const newSessionToken = () =>
  globalThis.crypto?.randomUUID?.() ||
  `${Date.now()}-${Math.random().toString(16).slice(2)}`;

export const toLatLng = (location) => {
  const lat = Number(location?.latitude ?? location?.lat);
  const lng = Number(location?.longitude ?? location?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
};

export const toBoundsLiteral = (viewport) => {
  const north = Number(viewport?.high?.latitude);
  const south = Number(viewport?.low?.latitude);
  const east = Number(viewport?.high?.longitude);
  const west = Number(viewport?.low?.longitude);
  if (![north, south, east, west].every(Number.isFinite)) return null;
  return { north, south, east, west };
};

export const readLatLng = (point) => {
  if (!point) return null;
  const lat = Number(
    typeof point.lat === "function" ? point.lat() : point.lat ?? point.latitude,
  );
  const lng = Number(
    typeof point.lng === "function" ? point.lng() : point.lng ?? point.longitude,
  );
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat === 0 && lng === 0) return null;
  return { lat, lng };
};

export const formatDistance = (distanceMeters) => {
  if (!Number.isFinite(distanceMeters)) return "";
  if (distanceMeters < 1000) return `${Math.round(distanceMeters)} m`;
  const km = distanceMeters / 1000;
  return `${km.toFixed(km < 10 ? 1 : 0)} km`;
};

const toRadians = (degrees) => (degrees * Math.PI) / 180;

export const haversineMeters = (origin, destination) => {
  if (!origin || !destination) return null;

  const earthRadiusMeters = 6371000;
  const dLat = toRadians(destination.lat - origin.lat);
  const dLng = toRadians(destination.lng - origin.lng);
  const lat1 = toRadians(origin.lat);
  const lat2 = toRadians(destination.lat);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;

  return 2 * earthRadiusMeters * Math.asin(Math.sqrt(a));
};
